// gsap
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default function switchBackground() {
    const target = ".js-switchBackground"; //表示を操作する対象を複数指定
    const isTarget = document.querySelector(target) != null;
    if (!isTarget) return; //対象の要素がなければ、処理終了

    ScrollTrigger.create({
        trigger: ".c-section--movie", //指定する要素が見えたら
        start: "0% 50%",
        endTrigger: ".wrapper", //終了処理の要素を指定
        end: "bottom 0%",
        // markers: true, //ガイドを表示
        toggleClass: {
            targets: target,
            className: "is-active",
        },
    });
}
